<top-alert *ngIf="hint" [message]="hint"></top-alert>
<editable-form [form]="form!" confirmLabel="Confirmar" (submit)="onSubmitClick()" (cancel)="onCancel()">
  <div class="row">
    <div class="row mb-4">
      <input-select [size]="12" label="Novo status" icon="" controlName="novo_status" [items]="this.statusService.getItem(this.tipo) || []" [disabled]="novoStatus.length ? 'true' : undefined"></input-select>
    </div>
    <div class="row">
      <input-textarea *ngIf="exigeJustificativa" [size]="12" [rows]="3" label="Justificativa" controlName="justificativa"></input-textarea>
    </div>
  </div>
</editable-form>